<!-- Generated template for the ResultRanglistListItemComponent component -->

<ion-item (click)="openResult()" *ngIf="result.place > 3 || !appDetector.isForestApp()">
	<!-- We don't show the place in Thurnau app -->
	<img slot="start" src="/assets/imgs/ranklist-1.png" class="place-image" *ngIf="result.place == 1 && !isThurnauApp">
	<img slot="start" src="/assets/imgs/ranklist-2.png" class="place-image" *ngIf="result.place == 2 && !isThurnauApp">
	<img slot="start" src="/assets/imgs/ranklist-3.png" class="place-image" *ngIf="result.place == 3 && !isThurnauApp">
	<p slot="start"  class="place-text text-center" *ngIf="result.place > 3 && !isThurnauApp">
		{{result.place}}
	</p> 
	<ion-row class="ion-align-items-center">
		<ion-col size="auto" *ngIf="!appDetector.isGesunderApp()">
			<ion-avatar>
				<img src="{{result.picName || '/assets/imgs/default-image-32@1x.png'}}">
			</ion-avatar>
		</ion-col>
		<ion-col size="auto" class="white-space-normal overflow-hidden">
			<div class="vertical-center-outer">
				<div class="vertical-center-inner">
					<h6 class="ion-text-bold" style="white-space: nowrap;">
						{{result.athleteName}}
						<span *ngIf="!appDetector.isForestApp()">
									{{ result.firstName }}
									{{ result.lastName }}
									{{ result.bibNo }}
						</span>
					</h6>
				</div>
			</div>
		</ion-col>
	</ion-row>
	<!-- We show the distance instead of time if it's Thurnau App -->
	<p slot="end" *ngIf="distance ">
		{{ result.streckeconv }}
	</p>
	<p slot="end" *ngIf="isThurnauApp">
		{{ result.streckeconv }}
	</p>
	<p slot="end" *ngIf="!isThurnauApp">
		{{ result.timeFormatted }}
	</p>
</ion-item>